import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { clearMessageGroupUnread, markMessageGroupRead } from "../actions/messageGroups.actions";
import { messageGroupsQueryKeys } from "../messageGroups.queryKeys";

export const useMessageGroupRead = (groupUid?: string, companyId?: number | string | null) => {
  const token = sessionStorage.getItem("token");
  const queryClient = useQueryClient();
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  const markRead = useCallback(async () => {
    if (!token || !groupUid || !effectiveCompanyId) return;

    queryClient.setQueryData(messageGroupsQueryKeys.list(effectiveCompanyId), (old: any) => clearMessageGroupUnread(old, groupUid));

    try {
      await markMessageGroupRead(token, groupUid, effectiveCompanyId);
    } catch (error) {
      queryClient.invalidateQueries({ queryKey: messageGroupsQueryKeys.list(effectiveCompanyId) });
    }
  }, [token, groupUid, effectiveCompanyId, queryClient]);

  return { markRead };
};
